export const SUNDAY = 0;
export const SATURDAY = 6;
